import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import LoggedOutControls from 'components/Auth/LoggedOutControls'
import { getDeviceInformation } from 'utils/helper'
import signInMarkettingImg from 'assets/signInMarkettingImg.png'
import UserSecurityIcon from 'assets/signIn/UserSecurityIcon.svg'
import ReputationDataIcon from 'assets/signIn/ReputationDataIcon.svg'
import BusinessInformationVerificationIcon from 'assets/signIn/BusinessInformationVerificationIcon.svg'
import FinancialGraphIcon from 'assets/signIn/FinancialGraphIcon.svg'

const sx = {
  root: {
    backgroundColor: '#fff',
    minHeight: '100vh',
    display: 'flex',
    flex: 1,
  },
  infoSection: {
    padding: '91px',
    width: '50%',
    backgroundSize: 'cover',
    [theme => theme.breakpoints.down(813)]: {
      display: 'none',
    },
  },
  formSection: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.blue5',
    paddingTop: theme => theme.spacing(9.5),
    [theme => theme.breakpoints.down(813)]: {
      width: '100%',
      padding: '0 50px',
    },
  },
  infoText: {
    textAlign: 'center',
    position: 'fixed',
    top: '50%',
  },
  headerMsg: {
    width: '538px',
    color: '#fff',
    textAlign: 'center',
    marginBottom: '35px',
    marginTop: '25px',
  },
  gettingStarted: {
    fontSize: '16px',
    color: 'color.aqua',
    textTransform: 'uppercase',
    marginBottom: '25px',
  },
  itemText: {
    color: 'color.white',
    minHeight: '80px',
    fontWeight: 400,
    display: 'flex',
    alignItems: 'center',
  },
  divider: {
    color: 'color.aqua',
    width: '538px',
  },
  itemsWrapper: {
    display: 'inline-flex',
    gap: 2,
    alignItems: 'center',
  },
  number: {
    borderRadius: '86.667px',
    backgroundColor: 'color.aqua',
    color: 'color.blue',
    width: '26px',
    height: '26px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 500,
  },
  imageWrapper: {
    borderRadius: '50%',
    aspectRatio: '1/1',
    backgroundColor: 'color.white',
    height: '56px',
    width: '56px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}

const items = [
  {
    text: 'Enter your email to create your account. ',
    icon: UserSecurityIcon,
    id: 1,
  },
  {
    text: 'Use our Directory to claim your business.',
    icon: ReputationDataIcon,
    id: 2,
  },
  {
    text: 'See the public snapshot of your business.',
    icon: BusinessInformationVerificationIcon,
    id: 3,
  },
  {
    text: 'Take action with new tools and solutions!',
    icon: FinancialGraphIcon,
    id: 4,
  },
]

const SignInLayout = ({ children, noAuthHeader }) => {
  const isAndroid = getDeviceInformation(window).includes('Android')
  const isIphone = getDeviceInformation(window).includes('iPhone')
  const isIpad = getDeviceInformation(window).includes('iPad')
  const isMobile = isAndroid || isIphone || isIpad

  return (
    <>
      {!isMobile ? (
        <Box sx={sx.root}>
          {!noAuthHeader && <LoggedOutControls controls={true} />}
          <Box sx={sx.infoSection} backgroundColor="color.blue">
            <Box
              display="flex"
              height="100%"
              width="100%"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              blockSize="auto"
            >
              <img
                src={signInMarkettingImg}
                style={{
                  width: '378px',
                  height: '280px',
                }}
                alt="sign-in-img"
              />
              <Typography variant="h5" sx={sx.headerMsg}>
                Unlock your business’s growth potential with faster access to the services and solutions you need
              </Typography>
              <Typography variant="overline1" sx={sx.gettingStarted}>
                Getting started is easy!
              </Typography>
              {items.map((item, index) => (
                <>
                  <Divider variant="middle" sx={sx.divider} />
                  <Box sx={sx.itemsWrapper}>
                    <Box>
                      <Typography variant="body1" sx={sx.number}>
                        {item.id}
                      </Typography>
                    </Box>
                    <Box sx={sx.imageWrapper}>
                      <img
                        src={item.icon}
                        alt={item.icon}
                        style={{
                          height: '35px',
                          width: '35px',
                        }}
                      />
                    </Box>
                    <Typography variant="quote2" color="color.white" sx={sx.itemText}>
                      {item.text}
                    </Typography>
                  </Box>
                </>
              ))}
            </Box>
          </Box>
          <Box sx={sx.formSection}>{children}</Box>
        </Box>
      ) : (
        <Box>
          <Box backgroundColor="color.blue">
            <Box sx={sx.wrapper}>
              <img
                src={signInMarkettingImg}
                style={{
                  width: '171px',
                  height: '127px',
                }}
                alt="sign-in-img"
              />
              <Typography variant="body1B" sx={sx.headerMsg}>
                Unlock your business’s growth potential with faster access to the services and solutions you need
              </Typography>
              <Typography variant="overline2" sx={sx.gettingStarted}>
                Getting started is easy!
              </Typography>
              {items.map((item, index) => (
                <>
                  <Divider variant="middle" sx={sx.divider} />
                  <Box sx={sx.itemsWrapper}>
                    <Box>
                      <Typography variant="body1" sx={sx.number}>
                        {item.id}
                      </Typography>
                    </Box>
                    <Box sx={sx.imageWrapper}>
                      <img
                        src={item.icon}
                        alt={item.icon}
                        style={{
                          height: '26.96px',
                          width: '26.96px',
                        }}
                      />
                    </Box>
                    <Typography variant="body2" color="color.white" sx={sx.itemText}>
                      {item.text}
                    </Typography>
                  </Box>
                </>
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </>
  )
}

export default SignInLayout
